import React, { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
const API_URL = process.env.REACT_APP_API_URL;

export default function ResetPassword() {
  const { token } = useParams();
  const navigate = useNavigate();

  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  const handleReset = async (e) => {
    e.preventDefault();
    setMessage("");
    setError("");

    if (newPassword !== confirmPassword) {
      setError("Passwords do not match.");
      return;
    }

    try {
      const res = await fetch(`${API_URL}/api/auth/reset-password/${token}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ newPassword }),
      });

      const data = await res.json();

      if (!res.ok) {
        setError(data.message || "Password reset failed.");
        return;
      }

      setMessage("✅ Password reset successful. Redirecting to login...");
      setTimeout(() => navigate("/login"), 3000);
    } catch (err) {
      setError("❌ Server error. Please try again.");
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-r from-blue-600 to-purple-700 px-6 py-12">
      <form
        onSubmit={handleReset}
        className="bg-white rounded-xl shadow-2xl p-10 max-w-md w-full"
      >
        <h2 className="text-3xl font-extrabold mb-6 text-center text-gray-900 tracking-wide">
          Reset Password
        </h2>

        {message && (
          <p className="mb-4 text-center text-green-700 bg-green-100 rounded-md py-2 px-4 font-medium">
            {message}
          </p>
        )}
        {error && (
          <p className="mb-4 text-center text-red-700 bg-red-100 rounded-md py-2 px-4 font-medium">
            {error}
          </p>
        )}

        <label className="block mb-2 font-semibold">New Password</label>
        <input
          type="password"
          className="w-full p-3 border rounded-lg mb-4"
          placeholder="Enter new password"
          value={newPassword}
          onChange={(e) => setNewPassword(e.target.value)}
          required
        />

        <label className="block mb-2 font-semibold">Confirm Password</label>
        <input
          type="password"
          className="w-full p-3 border rounded-lg mb-6"
          placeholder="Confirm new password"
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
          required
        />

        <button
          type="submit"
          className="w-full bg-gradient-to-r from-blue-600 to-purple-700 text-white font-bold py-3 rounded-lg shadow-lg transition duration-300 hover:opacity-90"
        >
          Reset Password
        </button>
      </form>
    </div>
  );
}
